import React, { useEffect, useState } from 'react'
import Unauthorized from './Unauthorized'
import { stockClient } from '../../services/SigninSetup'
import Loading from '../../components/Loading'

const BypassSecured = ({ claim, children }) => {
  const [authorized, setAuthorized] = useState(null)
  useEffect(() => {
    stockClient
      .checkClaim(claim)
      .then((authorization) => setAuthorized(authorization))
      .catch(() => setAuthorized(false))
  }, [claim])

  if (authorized === null) return <Loading />
  return authorized ? (
    <>{children}</>
  ) : (
    <div className="page-body">
      <Unauthorized />
    </div>
  )
}

export default BypassSecured
